import { createFileRoute, Outlet } from '@tanstack/react-router';
import styles from './payments.module.scss';

export const Route = createFileRoute('/$locale/smartbanking/payments')({
  component: PaymentsLayout,
});

function PaymentsLayout() {
  return (
    <div className={styles.paymentsWrapper}>
      <Outlet />
    </div>
  );
}
